let language = {
    CART_TABLE_TITLE_PRODUCT: "产品",
    CART_TABLE_TITLE_QUANTITY: " 数量",
    CART_TABLE_TITLE_UNITED_PRICE: "单价",
    CART_TABLE_TITLE_PRICE: "价格",
    CART_TABLE_TITLE_OPERATION: "操作",
    CART_TABLE_TITLE_PREVIEW: "预览",
    CART_TABLE_TITLE_NAME: "名字",
    CART_TABLE_TITLE_EDIT: "编辑",
    CART_ADD_TO_STORE:"添加到商店",
    CART_EMPTY:"购物车空了！",
    CART_GO_SHOPPING:"购买",
    CART_CONTINUE:"继续",
    
}

export { language }